import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from '../store/slices/authSlice';
import { protectedRoutes, publicRoutes , micRoutes, zicRoutes,stationRoutes,adminRoutes,HrirRoutes, OmcRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import {message} from 'antd'
import secureLocalStorage from 'react-secure-storage';


const Routes = () => {
	
	const user = secureLocalStorage.getItem('user_role')
	//const user = JSON.parse(Nme)
	//let mainRoute
	let mainRoute = protectedRoutes;
	if (user ) {
		if (user=== "station"){
			mainRoute = stationRoutes
		}
		else if(user === "MIC"){
			mainRoute = micRoutes
		}
		else if (user === "ZIC") {
			mainRoute = zicRoutes
		}
		else if (user === "hrir") {
			mainRoute = HrirRoutes
		}
		else if (user == "omc") {
			mainRoute = OmcRoutes
		}
		else {
			mainRoute = adminRoutes
		}
	}

	return (
		<RouterRoutes>
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
				{mainRoute.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to={`${APP_PREFIX_PATH}/NotFound`}   replace />} />
				
			</Route>
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/ >
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes